import { domain, LocationCookie, ZipCodeCookie, PersistentZipCodeCookie } from './constants';
import * as locationParser from './locationParser';
const FIRST_DATE = new Date(0);
export const updateZipcodeCookies = (newGlobalZipInfo, setCookie) => {
  const cookieValue = locationParser.encode(newGlobalZipInfo);
  setCookie(LocationCookie, cookieValue, {
    domain,
    path: '/'
  });
  setCookie(ZipCodeCookie, newGlobalZipInfo.zip, {
    expires: FIRST_DATE
  });
  setCookie(PersistentZipCodeCookie, newGlobalZipInfo.zip, {
    expires: FIRST_DATE
  });
  const cookieAge = 60 * 60 * 24 * 30;
  const now = new Date();
  const expirationDate = new Date(now.valueOf() + cookieAge * 1000);
  const cookieOptionsForZipCode = {
    path: '/',
    maxAge: cookieAge,
    expires: expirationDate
  };
  setCookie(ZipCodeCookie, newGlobalZipInfo.zip, cookieOptionsForZipCode);
  setCookie(PersistentZipCodeCookie, newGlobalZipInfo.zip, cookieOptionsForZipCode);
};